// extracted by mini-css-extract-plugin
export default {"row":"DashboardRow_row__XWmAa","row2col":"DashboardRow_row2col__BgdlN"};